var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgForwardArrowLinline = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  shapeRendering: "geometricPrecision",
  viewBox: "0 0 52 52"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 50,
  height: 50,
  x: 1,
  y: 1,
  fill: "#0E5741",
  rx: 25
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.6,
  d: "M11.4227 5.6875C15.5263 2.73737 20.5603 1 26 1C39.8071 1 51 12.1929 51 26C51 39.8071 39.8071 51 26 51C12.1929 51 1 39.8071 1 26C1 23.8419 1.27346 21.7476 1.78761 19.75",
  vectorEffect: "non-scaling-stroke"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeWidth: 0.75,
  d: "M26.2427 32.2497L32.4927 25.9997M32.4927 25.9997L26.2427 19.7497M32.4927 25.9997H19.9941",
  className: "button-arrow"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeWidth: 0.75,
  d: "M26.2427 32.2497L32.4927 25.9997M32.4927 25.9997L26.2427 19.7497M32.4927 25.9997H19.9941",
  className: "button-arrow-alt"
})));
export default SvgForwardArrowLinline;